<template>
  <div id="landing_charts" class="modal_mask">
    <div class="wrapper_modal_expand_chart">
      <div class="content_expand_chart">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          @click="toggleModalExpandChart()"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>

        <trade-chart v-if="chartData.length > 0" :chartData="chartData"></trade-chart>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import TradeChart from "../../components/public/charts_component/TradeChart";

export default {
  created() {
    this.getHistoryAll();
  },
  data: () => ({
    chartData: [],
    startDateChartAll: "2018-12-04T00:00:09.0Z",
    positiveTotal: "",
    chartsHour: {
      data: false,
      step: "",
      type: "hour",
      min: "",
    },
    chartsDay: {
      data: false,
      step: "",
      type: "day",
      min: "",
    },
    chartsWeek: {
      data: false,
      step: "",
      type: "week",
      min: "",
    },

    chartsMonth: {
      data: false,
      step: "",
      type: "month",
      min: "",
    },

    chartsYear: {
      data: false,
      step: "",
      type: "year",
      min: "",
    },

    chartsYTD: {
      data: false,
      step: "",
      type: "ytd",
      min: "",
    },

    chartsAll: {
      data: false,
      step: "",
      type: "all",
      min: "",
    },

    chartLoading: true,
    chartParams: false,
    chartMode: "all",
  }),
  components: {
    TradeChart,
  },
  methods: {
    toggleModalExpandChart() {
      this.$emit("toggleModalExpandChart");
    },
    setChartLoading(bol) {
      this.chartLoading = bol;
    },
    toggleChart(mode) {
      this.chartMode = mode;
      if (mode == "hour") {
        if (!this.chartsHour.data) {
          this.getHistoryHour();
        } else {
          this.setChart("hour");
        }
      }

      if (mode == "day") {
        if (!this.chartsDay.data) {
          this.getHistoryDay();
        } else {
          this.setChart("day");
        }
      }

      if (mode == "week") {
        if (!this.chartsWeek.data) {
          this.getHistoryWeek();
        } else {
          this.setChart("week");
        }
      }

      if (mode == "month") {
        if (!this.chartsMonth.data) {
          this.getHistoryMonth();
        } else {
          this.setChart("month");
        }
      }

      if (mode == "year") {
        if (!this.chartsYear.data) {
          this.getHistoryYear();
        } else {
          this.setChart("year");
        }
      }

      if (mode == "ytd") {
        if (!this.chartsYTD.data) {
          this.getHistoryYTD();
        } else {
          this.setChart("ytd");
        }
      }

      if (mode == "all") {
        if (!this.chartsAll.data) {
          this.getHistoryAll();
        } else {
          this.setChart("all");
        }
      }
    },

    async getHistoryHour() {
      let dateStart = new Date();
      let dateEnd = new Date();
      dateEnd.setHours(dateEnd.getHours() - 1);
      let endHour = this.sharedActions.formatDateTimeHistory(dateEnd);

      dateStart.setHours(dateStart.getHours() - 2);
      let startHour = this.sharedActions.formatDateTimeHistory(dateStart);

      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 1,
        sumbols: "blu",
      };

      let resp = await this.$store.dispatch("getCurrenciesHistory", params);

      this.chartsHour.data = resp.data[0].history;
      this.getMinStep(resp.data[0].history, "hour");
    },

    async getHistoryDay() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setHours(0);
      date.setMinutes(0);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 60,
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsDay.data = resp.data[0].history;

      this.getMinStep(resp.data[0].history, "day");
    },

    async getHistoryWeek() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setDate(date.getDate() - 7);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsWeek.data = resp.data[0].history;
      this.setChart("week");
    },

    async getHistoryMonth() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setMonth(date.getMonth() - 1);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: "1D",
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsMonth.data = resp.data[0].history;
      this.setChart("month");
    },

    async getHistoryYear() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setFullYear(date.getFullYear() - 1);
      let startHour = this.sharedActions.formatDateTimeHistory(date);
      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };
      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsYear.data = resp.data[0].history;
      this.setChart("year");
    },

    async getHistoryYTD() {
      let date = new Date();
      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setFullYear(date.getFullYear(), 0, 1);

      let startHour = this.sharedActions.formatDateTimeHistory(date);

      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };

      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartsYTD.data = resp.data[0].history;
      this.setChart("ytd");
    },

    async getHistoryAll() {
      let date = new Date();

      let endHour = this.sharedActions.formatDateTimeHistory(date);
      date.setFullYear(2018);

      let startHour = this.sharedActions.formatDateTimeHistory(
        this.startDateChartAll
      );

      let params = {
        start: startHour + ".0Z",
        end: endHour + ".0Z",
        pair: "usdt",
        period: 720,
        sumbols: "blu",
      };

      let resp = await this.$store.dispatch("getCurrenciesHistory", params);
      this.chartData = resp.data[0].history;

      this.chartsAll.data = resp.data[0].history;

      this.getMinStep(resp.data[0].history, "all");
    },

    getMinStep(resp, type) {
      let max = 0;
      let min = 1000;
      let step = "";

      for (let i in resp) {
        if (resp[i].close < min) {
          min = resp[i].close;
        }
        if (resp[i].close > max) {
          max = resp[i].close;
        }
      }

      let minFixed = min.toFixed();
      min = min.toFixed(2);
      max = max.toFixed(2);
      step = (max - min).toFixed(2) / 2;

      min = min - step * 2;

      if (type == "hour") {
        // min = min + 0.03
        this.chartsHour.min = min.toFixed(2);
        this.chartsHour.step = step;
        this.setChart("hour");
      }

      if (type == "day") {
        this.chartsDay.min = min.toFixed(2);
        this.chartsDay.step = step;
        this.setChart("day");
      }

      if (type == "year") {
        this.chartsYear.min = min.toFixed(2);
        this.chartsYear.step = step;
        this.setChart("year");
      }

      if (type == "all") {
        this.chartsAll.min = min.toFixed();
        this.chartsAll.step = step.toFixed();
        this.setChart("all");
      }

      console.log(this.chartsYear.min);
      console.log(this.chartsYear.step);

      console.log(this.chartsAll.min);
      console.log(this.chartsAll.step);
    },

    setChart(mode) {
      if (mode == "hour") {
        this.chartParams = this.chartsHour;
      } else if (mode == "day") {
        this.chartParams = this.chartsDay;
      } else if (mode == "week") {
        this.chartParams = this.chartsWeek;
      } else if (mode == "month") {
        this.chartParams = this.chartsMonth;
      } else if (mode == "year") {
        this.chartParams = this.chartsYear;
      } else if (mode == "ytd") {
        this.chartParams = this.chartsYTD;
      } else if (mode == "all") {
        this.chartParams = this.chartsAll;
      }
    },
  },
  computed: {
    ...mapGetters(["bluValue"]),
  },
};
</script>


<style lang="scss" scope>
.modal_mask {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
  overflow: auto;
}

.wrapper_modal_expand_chart {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .content_expand_chart {
    position: relative;
    padding: 2rem 2.5rem;
    border-radius: 6px;
    max-width: 1000px;
    height: auto;
    width: 100%;
    background-color: #fff;

    svg {
      position: absolute;
      top: 0.5rem;
      width: 1.2rem;
      right: 0.5rem;
      cursor: pointer;

      &:hover {
        color: #342365;
      }
    }

    .landing_charts_label {
      .price_blue_chart {
        display: flex;
      }
    }
  }
}

@media only screen and (max-width: 900px) {
  .wrapper_modal_expand_chart {
    .content_expand_chart {
      max-width: 600px;
      padding: 1rem 1.5rem;

      svg {
        top: 0.3rem;
        right: 0.3rem;
        width: 1rem;
      }
    }
  }
}

@media only screen and (max-width: 380px) {
  .wrapper_modal_expand_chart {
    .content_expand_chart {
      max-width: 350px;
      padding: 0.5rem 1rem;

      #landing_charts {
        .combo_buttons_charts {
          justify-content: center !important;
        }
      }

      .landing_charts_label {
        padding: 0rem !important;
        justify-content: center;
        flex-wrap: nowrap;
        flex-direction: column;
        align-items: center;
      }

      .link_switch {
        margin: 1% !important;
      }
    }
  }
}

@media only screen and (max-width: 350px) {
  .wrapper_modal_expand_chart {
    .content_expand_chart {
      max-width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalExpandChart.vue